export default __webpack_public_path__ + "static/media/lionsLogo.dcc8cf25.png";